const adaptInsumo = (valorEsperado) => {
  const { idInsumoN, descripcion, idUnidad, unidad } = valorEsperado;

  return {
    id: idInsumoN,
    label: `${idInsumoN} - ${descripcion}`,
    descripcion, 
    idUnidad,
    unidad,
  };
};

export const adaptIndicacionInsumosDispo = (data) => {
  return (
    data?.indicacionInsumosDispo?.valorEsperado?.map((insumo) =>
      adaptInsumo(insumo)
    ) || []
  );
};
